export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-404w-31a53dc64bd3a9c83a11f83e365e7fda.webp";